import { render, staticRenderFns } from "./InjectionMachineDetails.vue?vue&type=template&id=21b3ff51&"
import script from "./InjectionMachineDetails.vue?vue&type=script&lang=js&"
export * from "./InjectionMachineDetails.vue?vue&type=script&lang=js&"
import style0 from "./InjectionMachineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports